import { i18nLanguage } from "i18n";
import { TripperDisplayMode } from "./types";
import { TripperWidget } from "./TripperWidget";
import { TripperTextButton } from "./components/TripperTextButton";
import { TripperRichPreview } from "./components/TripperRichPreview";

type TripperWidgetRouterProps = {
  itineraryId: string;
  language: i18nLanguage;
  displayMode: TripperDisplayMode;
  label?: string;
};

export const TripperWidgetRouter = ({
  itineraryId,
  language,
  displayMode,
  label,
}: TripperWidgetRouterProps) => {
  switch (displayMode) {
    case "text-button":
      return (
        <TripperTextButton
          itineraryId={itineraryId}
          language={language}
          label={label}
        />
      );
    case "rich-preview":
      return (
        <TripperRichPreview
          itineraryId={itineraryId}
          language={language}
        />
      );
    default:
      return (
        <TripperWidget
          itineraryId={itineraryId}
          language={language}
          displayMode={displayMode}
        />
      );
  }
};
